export enum SeatStatus {
  Accepted,
  Invited,
  Picked,
  Declined,
  NoResponse,
  NoShow,
  Bench
}

export class SeatStatusInfo {
  public static sortRanking(status?: SeatStatus): number {
    switch (status) {
      case SeatStatus.Accepted:
        return 1;
      case SeatStatus.Invited:
        return 2;
      case SeatStatus.Picked:
        return 3;
      case SeatStatus.Declined:
        return 4;
      case SeatStatus.NoResponse:
        return 5;
      case SeatStatus.NoShow:
        return 6;
      case SeatStatus.Bench:
        return 7;
      default:
        return 0;
    }
  }
}
